import React, { Component } from 'react'
import isNil from 'lodash.isnil'
import get from 'lodash.get'
import PropTypes from 'prop-types'
import axios from 'axios'
import { injectIntl } from 'react-intl'

import MapContainer from 'src/components/Maps/ReactGoogleMaps'
import { Layout, Content, Container, PageTitle } from 'src/components/Layout'
import { Loader } from 'src/components/Loader'
import { parseGoogleResponse, logError } from 'src/utils/helpers'
import withToast from 'src/components/Toast'
import LocationOfflineForm from './LocationOfflineForm'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from './translations'
import { WidgetContext } from 'src/modules/App/WidgetContext'

import styles from './Location.module.less'

const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY

class Location extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  state = {
    loading: false,
    isOffline: false,
    claimLocation: null,
    data: null,
    isFindMeLoading: false,
    isFindMe: false,
  }

  componentDidMount() {
    if (!isNil(this.props.claimLocation)) {
      this.setState({
        claimLocation: this.props.claimLocation,
      })
    }

    this.getGeoLocationStatus()

    if (!this.props.isOffline.online) {
      this.setState({
        isOffline: true,
      })
    }
  }

  getGeoLocationStatus() {
    this.setState({ loading: true })
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, showError)
    } else {
      logError('Geolocation is not supported on your browser!')
    }
    let $this = this
    function success() {
      if ($this.props.isOffline.online) {
        $this.getLocation()
      } else {
        $this.setState({
          // isOffline: true,
          loading: false,
        })
      }
    }

    function showError(error) {
      $this.setState({
        isOffline: true,
        loading: false,
      })
      switch (error.code) {
        case error.PERMISSION_DENIED:
          logError(
            'Comments are only permitted when location sharing is enabled- you have denied the request for Geolocation.',
          )
          break
        case error.POSITION_UNAVAILABLE:
          logError(
            'Comments are only permitted when location sharing is enabled- Location information is unavailable.',
          )
          break
        case error.TIMEOUT:
          logError(
            'Comments are only permitted when location sharing is enabled- the request to get user location timed out.',
          )
          break
        case error.UNKNOWN_ERROR:
          logError(
            'Comments are only permitted when location sharing is enabled- An unknown error occurred.',
          )
          break
      }
    }
  }

  onPlaceChange = location => {
    this.setState({
      data: location,
      isFindMe: false,
    })
  }

  onSubmit = claimLocation => {
    this.props.setLocation(claimLocation)
    this.goBack()
  }

  goBack = () => {
    this.props.history.push('/claims/form')
  }

  getLocation = () => {
    const { intl, toast } = this.props

    this.setState({ loading: true })
    navigator.geolocation.getCurrentPosition(
      position => {
        const claimLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
        this.getLocationInfo(claimLocation)
          .then(address => {
            this.setState(
              {
                claimLocation: claimLocation,
                loading: false,
              },
              () => {
                this.setState({
                  data: {
                    ...address,
                    ...claimLocation,
                  },
                })
              },
            )
          })
          .catch(() => {
            toast({
              title: intl.formatMessage(intlMessagesApp.appErrorTitle),
              description: intl.formatMessage(intlMessages.locationNotFound),
              status: 'error',
            })
          })
      },
      () => {
        this.setState({
          loading: false,
          isOffline: true,
        })
      },
    )
  }

  getLocationInfo = geoLocation => {
    return new Promise((resolve, reject) => {
      const latLng = `${geoLocation.lat},${geoLocation.lng}`
      const instance = axios.create()
      instance.defaults.headers.common = {}
      instance
        .get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng}&key=${googleApiKey}`,
        )
        .then(({ data }) => {
          const address = get(data.results, '0.address_components', {})
          if (!address) {
            reject('No address found')
          }
          resolve(parseGoogleResponse(address))
        })
    })
  }

  handleConfirm = () => {
    this.props.setLocation(this.state.data)
    this.goBack()
  }

  findMe = () => {
    if (navigator.geolocation) {
      this.getLocation(true)
    }
  }

  render() {
    const { claimLocation, isOffline, loading, isFindMeLoading, isFindMe } = this.state
    const { intl } = this.props

    return (
      <Layout>
        <Content>
          <PageTitle
            title={intl.formatMessage(intlMessages.locationHeadline)}
            subtitle={intl.formatMessage(intlMessages.claimsFillOutTheForm)}
          />
          <Container
            className={isOffline && !loading ? 'global-centered-desktop-content' : styles.container}
          >
            <Loader styleVariation='staticWithHeight' display-if={loading} />
            <LocationOfflineForm
              locationText={
                claimLocation && claimLocation.locationText ? claimLocation.locationText : ''
              }
              onSubmit={this.onSubmit}
              display-if={isOffline && !loading}
            />
            <MapContainer
              isWidget={this.props.isWidget}
              onPlaceChange={this.onPlaceChange}
              onFindMe={this.findMe}
              onConfirm={this.handleConfirm}
              isOnline={this.props.isOffline.online}
              findLocationPlaceholder={intl.formatMessage(
                intlMessages.locationFindLocationPlaceholder,
              )}
              confirmLocationButton={intl.formatMessage(intlMessagesApp.appGlobalConfirm)}
              display-if={!isOffline && !loading}
              isFindMeLoading={isFindMeLoading}
              isFindMe={isFindMe}
              defaultZoom={15}
              {...claimLocation}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

const LocationContext = props => (
  <WidgetContext.Consumer>{context => <Location {...props} {...context} />}</WidgetContext.Consumer>
)

export default injectIntl(withToast(LocationContext))
